<app-claim-edit *ngIf="claimListorEdit" [EditClaim]="isListorUpdateView"
    (EditClaimemit)="EmitChildComponent($event)"></app-claim-edit>

<app-claim-list *ngIf="!claimListorEdit" [claimLsitEmitBo]="isListorUpdateView"
    (claimListEmit)="EmitChildComponent($event)"></app-claim-list>